import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { CountryPhone } from "./CountryPhone";
import { BranchDetail } from "./BranchDetail";
import { Branch } from "../../../../../../../Wrap/Models/Models/Company/Branch";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { BankAddress } from "./BankAddress";
import { ContactOwnerType } from "../../../../../../../Wrap/Models/Models/Instructions/ContactOwnerType";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";

interface IAddBranchProps extends React.Props<AddBranch> {
    isReview?: boolean;
    data: Branch;
    onChange: (changes) => void;
    onClickSave: VoidFunction;
    onClickCancel: VoidFunction;
    currentFirm: FirmInstruction;
}

export class AddBranch extends FormComponent<IAddBranchProps, {}> {
    constructor(props: any) {
        super(props);
    }

    child: Array<any> = [];

    isValid(): boolean {
        let flag = true;
        this.child.reverse().forEach((element) => {
            const isValid = element.isValid();
            if (!isValid) {flag = false;}
        });
        return flag;
    }

    private onSave() {
        const flag = this.isValid();
        if (flag) {this.props.onClickSave();}
    }

    private onUseFirmAddressChange(use: boolean): void {
        this.props.onChange({ UseFirmAddress: use });
        const firm = this.props.currentFirm?.CompanyAddress?.Address;
        if (use) {
            this.props.onChange({
                BranchAddress: {
                    Address: {
                        InstructionId: this.props.data.BranchId,
                        Line1: firm.Line1,
                        Line2: firm.Line2,
                        Line3: firm.Line3,
                        Line4: firm.Line4,
                        Line5: firm.Line5,
                        PostCode: firm.PostCode,
                        OwnerType: ContactOwnerType.Branch,
                        CountryCode: firm.CountryCode,
                    },
                },
            });
        }
    }

    render() {
        const { data } = this.props;
        return (
            <>
                <BranchDetail
                    isReview={this.props.isReview}
                    data={data}
                    onChange={(changes) => this.props.onChange(changes)}
                    onRef={(ref) => this.child.push(ref)}
                />
                <hr />
                <CountryPhone
                    isReview={this.props.isReview}
                    key={"phone"}
                    onChange={(v) => this.props.onChange({ PhoneNumber: v })}
                    sectionHeader="Phone number"
                    data={data.PhoneNumber}
                    onRef={(ref) => this.child.push(ref)}
                    required={true}
                />
                <hr />
                <CountryPhone
                    isReview={this.props.isReview}
                    key={"fax"}
                    onChange={(v) => this.props.onChange({ FaxNumber: v })}
                    sectionHeader="Fax number"
                    data={data.FaxNumber}
                    onRef={(ref) => this.child.push(ref)}
                />
                <hr />
                <CheckboxGroup
                    type="block"
                    options={[
                        {
                            label: "Use firm address",
                            value: data.UseFirmAddress || false,
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                this.onUseFirmAddressChange(v);
                            },
                        },
                    ]}
                />
                {!data.UseFirmAddress && (
                    <BankAddress
                        isReview={this.props.isReview}
                        onRef={(ref) => this.child.push(ref)}
                        address={data.BranchAddress}
                        onChange={(v) => this.props.onChange({ BranchAddress: v })}
                    />
                )}
                <div className="row vspace-top-24">
                    <div className="col-auto">
                        <button className="btn secondary" onClick={() => this.onSave()} disabled={this.props.isReview}>
                            Save branch
                        </button>
                    </div>
                    <div className="col-auto">
                        <button className="btn secondary" onClick={this.props.onClickCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            </>
        );
    }
}
